export const FETCH_COLLECTIONS_START = 'FETCH_COLLECTIONS_START';
export const FETCH_COLLECTIONS_SUCCESS = 'FETCH_COLLECTIONS_SUCCESS';
export const FETCH_COLLECTIONS_FAILURE = 'FETCH_COLLECTIONS_FAILURE';

export const CONFIRMED_MAP = 'CONFIRMED_MAP';
export const DEATHS_MAP = 'DEATHS_MAP';
export const RECOVERED_MAP = 'RECOVERED_MAP';